// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** Official Details Add Start ************************/
export const officialMemberdetailsAdd = (verifyData: any) => {
	const data = {
		CreateOfficialDetailsToken: verifyData,
	};
	const url = `${API_URL}addOfficialDetails`;
	return makeApiCall(url, data);
};
/** ***************** Official Details Add End ************************/

/** ***************** Economic Activity List Start ************************/
export const getEconomicActivityList = (verifyData: any) => {
	const data = {
		GetAllEconomicActivityListToken: verifyData,
	};
	const url = `${API_URL}getAllEconomicActivity`;
	return makeApiCall(url, data);
};
/** ***************** Economic Activity List End ************************/
